import { BROWSER_EXTENSION_ORIGINS } from 'extension-communication/lib/constants/extensionOrigin';
import { isOpx } from 'owa-opx/lib/isOpx';

export const listenMessageFromExtension = (callback: (event: MessageEvent) => void): void => {
    if (isOpx()) {
        window.addEventListener(
            'message',
            (event: MessageEvent) => {
                if (!BROWSER_EXTENSION_ORIGINS.includes(event.origin)) {
                    return;
                }
                callback(event);
            },
            false
        );
    }
};
